import { Box, Typography, Link } from "@mui/material";
import liff from "../../../lib/liff";
import { useTranslation } from "react-i18next";

import StyledButton from "default/components/StyledButton";
import { useUrlParams } from "hooks/useUrlParams";
import HowToUseSlider from "default/components/HowToUseSlider";
import PotionLayout from "../components/PotionLayout";
import HowToUseAccordion from "../components/HowToUseAccordion";
import {
  getRequestFormUrl,
  getGuidelinesUrl,
  howToUseDetailUrls,
} from "constants/links";

const LINE_STAMP_URL =
  "https://store.line.me/stickershop/product/32940098";

function HowToUse() {
  const { soulId, lng, work } = useUrlParams();
  const { t } = useTranslation(["common", work]);
  const requestFormUrl = getRequestFormUrl(lng);
  const guidelineUrl = getGuidelinesUrl(work, lng);

  const tamilSection = t(`${work}:HowToUseSections.tamil`, {
    returnObjects: true,
  });
  const conversationLimitSection = t(`${work}:HowToUseSections.conversationLimit`, {
    returnObjects: true,
  });
  const lineStampSection = t(`${work}:HowToUseSections.lineStamp`, {
    returnObjects: true,
  });

  const handleNavigateToHowToUseDetail = () => {
    const urls = howToUseDetailUrls["potion"] || howToUseDetailUrls["common"];
    const url = urls[lng] || urls["ja"];
    window.open(url, "_blank");
  };

  const handleNavigateToGuideLine = () => {
    window.open(guidelineUrl, "_blank");
  };

  const handleCloseWindow = () => {
    liff.closeWindow();
  };

  const handleNavigateToRequestForm = () => {
    window.open(requestFormUrl, "_blank");
  };

  const handleNavigateToContact = () => {
    window.open("https://line.me/R/ti/p/@314jdaww", "_blank");
  };

  return (
    <PotionLayout>
      <Box
        sx={{
          display: "flex",
          paddingTop: 6,
          paddingBottom: 4,
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 5,
          }}
        >
          <Typography
            sx={{
              fontFamily: "Kaisei Decol, serif",
              color: "#13433a",
              fontSize: "20px",
              fontWeight: "bold",
              textShadow: "0px 0px 8px #FFFFFF, 0px 0px 8px #FFFFFF, 0px 0px 8px #FFFFFF",
              WebkitTextStroke: "0.5px #FFFFFF",
              paintOrder: "stroke fill",
            }}
          >
            {t("common:HowToUse.Title")}
          </Typography>
        </Box>

        <HowToUseSlider />

        {/* Accordion Sections */}
        <Box sx={{ width: "90%", maxWidth: 420, marginTop: 5, display: "flex", flexDirection: "column", gap: 2 }}>
          <HowToUseAccordion title={tamilSection.title}>
            <Box component="ul" sx={{ margin: 0, paddingLeft: "1.2em" }}>
              {tamilSection.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </Box>
          </HowToUseAccordion>

          <HowToUseAccordion title={conversationLimitSection.title}>
            <Box component="ul" sx={{ margin: 0, paddingLeft: "1.2em" }}>
              {conversationLimitSection.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </Box>
          </HowToUseAccordion>

          <HowToUseAccordion title={lineStampSection.title}>
            <Typography
              sx={{
                fontFamily: "Kiwi Maru, serif",
                fontSize: "14px",
                color: "#13433a",
                lineHeight: 1.8,
                marginBottom: 2,
              }}
            >
              {lineStampSection.description}
            </Typography>
            <Link
              href={LINE_STAMP_URL}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                fontFamily: "Kaisei Decol, serif",
                fontSize: "14px",
                color: "#13433a",
                fontWeight: "bold",
                textDecorationColor: "#13433a",
              }}
            >
              {lineStampSection.linkLabel}
            </Link>
          </HowToUseAccordion>
        </Box>

        <StyledButton
          variant="contained"
          sx={{ marginTop: 6 }}
          onClick={handleNavigateToHowToUseDetail}
        >
          {t("common:HowToUse.Detail")}
        </StyledButton>

        <StyledButton
          variant="contained"
          sx={{ marginTop: 4 }}
          onClick={handleNavigateToGuideLine}
        >
          {t("common:HowToUse.GuideLines")}
        </StyledButton>

        <StyledButton
          variant="contained"
          sx={{ marginTop: 4 }}
          onClick={handleCloseWindow}
        >
          {t("common:button.back_to_chat")}
        </StyledButton>

        {requestFormUrl && (
          <StyledButton
            variant="contained"
            sx={{ marginTop: 4 }}
            onClick={handleNavigateToRequestForm}
          >
            {t("common:button.request_form")}
          </StyledButton>
        )}

        <StyledButton
          variant="contained"
          sx={{ marginTop: 4 }}
          onClick={handleNavigateToContact}
        >
          {t("common:HowToUse.Contact")}
        </StyledButton>

      </Box>
    </PotionLayout>
  );
}

export default HowToUse;
